'use strict';
import React from 'react';
import * as T from 'prop-types';
import {NavigationBar, navigationBarLinkProps} from '../../../components/views/NavigationBar';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {Link} from '../../../app/components/Link';
import {
  ASSET_FILE_REQUIREMENT_COLLECTION,
  ASSET_FORM_REQUIREMENT_COLLECTION,
  FILE_REQUIREMENT_COLLECTION,
  FORM_REQUIREMENT_COLLECTION,
} from '../../domain/config';
import {
  assetFileRequirementStates,
  assetFormRequirementStates,
  projectFileRequirementStates,
  projectFormRequirementStates,
} from '../../router-config';


export function BaseRequirementNavigationBarView(props) {
  const {
    detailsTitle,
    /** @type {RouterRequirementStates} */
    routerStates,
  } = getRouterState(props.collection);
  const toParams = props.navState && props.navState.currentParams;

  return (
    <NavigationBar>
      <Link
        {...navigationBarLinkProps}
        navState={props.navState}
        to={routerStates.details}
        toParams={toParams}
      >
        {props[detailsTitle]}
      </Link>
      <Link
        {...navigationBarLinkProps}
        navState={props.navState}
        to={routerStates.activityFeed}
        toParams={toParams}
      >
        {props.activityFeedTitle}
      </Link>
    </NavigationBar>
  );
}

BaseRequirementNavigationBarView.propTypes = {
  className: T.string,
  collection: T.string.isRequired,
  navState: T.object,

  fileTitle: T.string,
  formTitle: T.string,
  activityFeedTitle: T.string,
};

export const RequirementNavigationBarView = I18nComponent(BaseRequirementNavigationBarView, [
  {code: 'requirements.views.files.title', prop: 'fileTitle'},
  {code: 'requirements.views.form.title', prop: 'formTitle'},
  {code: 'requirements.views.activity.title', prop: 'activityFeedTitle'},
]);

/**
 * @param {String} collection
 * @return {{detailsTitle: 'fileTitle'|'formTitle', routerStates: RouterRequirementStates}}
 */
export function getRouterState(collection) {
  switch (collection) {
    case ASSET_FILE_REQUIREMENT_COLLECTION:
      return {
        detailsTitle: 'fileTitle',
        routerStates: assetFileRequirementStates,
      };

    case ASSET_FORM_REQUIREMENT_COLLECTION:
      return {
        detailsTitle: 'formTitle',
        routerStates: assetFormRequirementStates,
      };

    case FILE_REQUIREMENT_COLLECTION:
      return {
        detailsTitle: 'fileTitle',
        routerStates: projectFileRequirementStates,
      };

    case FORM_REQUIREMENT_COLLECTION:
      return {
        detailsTitle: 'formTitle',
        routerStates: projectFormRequirementStates,
      };
  }
}



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementNavigationBar/RequirementNavigationBarView.js